<article>
  <opac-avatar [style.--background-color]="comment.user.profilePicture.color" [picture]="comment.user.profilePicture.pictureUrl">
    {{ comment.user.profilePicture.content | avatarText }}
  </opac-avatar>

  <div class="content">
    <header>
      <span class="username">{{ comment.user.name }}</span>
      <time [dateTime]="comment.creationDate">
        <span>{{ comment.creationDate | date: 'mediumDate' }}</span>
        <opac-divider [vertical]="true"></opac-divider>
        <span>{{ comment.creationDate | date: 'shortTime' }}</span>
      </time>
    </header>

    <p>
      <b *ngIf="comment.replyUser">{{ comment.replyUser.name}} </b>
      <span [innerHTML]="comment.comment"></span>
    </p>

    <footer>
      <span>
        <opac-button [disabled]="!loggedUser()" [opacTooltip]="loggedUser() && ('info.comments.likeButtonTooltip' | translate)" [ariaLabel]="'info.comments.likeButtonLabel' | translate" (click)="like()">
          <opac-icon icon="like" slot="only-icon"></opac-icon>
        </opac-button>

        <span [attr.aria-label]="'info.comments.likeTextLabel' | translate">{{ comment.likes }}</span>
      </span>

      <span>
        <opac-button [disabled]="!loggedUser()" [opacTooltip]="loggedUser() && ('info.comments.dislikeButtonTooltip' | translate)" [ariaLabel]="'info.comments.dislikeButtonLabel' | translate" (click)="dislike()">
          <opac-icon icon="dislike" slot="only-icon"></opac-icon>
        </opac-button>

        <span [attr.aria-label]="'info.comments.dislikeTextLabel' | translate">{{ comment.dislikes }}</span>
      </span>

      <opac-button *ngIf="showReplyButton()" type="text" (click)="showTextarea()">
        {{ 'info.comments.actions.reply' | translate }}
      </opac-button>

      <opac-button *ngIf="showDeleteButton()" type="text" (click)="showDeleteCommentConfirmModal.set(true)">
        {{ 'info.comments.actions.delete' | translate }}
      </opac-button>
    </footer>

    <div *ngIf="openTextareaId() === textareaId()" class="reply-container">
      <app-edit-comment
        [textareaId]="textareaId()"
        [username]="parentId !== null && comment.user.name"
        (submitReply)="reply($event)"
        (cancelReply)="hideTextarea()"
      ></app-edit-comment>
    </div>

    <opac-button *ngIf="comment.repliesApprovedCount > 0" type="text" class="replies-button" [class.expanded]="showReplies()" (click)="toggleReplies()">
      {{ 'info.comments.replies' | translate:{ count: comment.repliesApprovedCount } }}
      <opac-icon icon="expand_more" slot="end"></opac-icon>
    </opac-button>

    <div *ngIf="showReplies()" class="replies-container">
      <ng-container *ngIf="comment.replies?.data">
        <app-comment *ngFor="let reply of comment.replies.data; trackBy trackCommentsFn" [comment]="reply" [parentId]="comment.id" [recordId]="recordId"></app-comment>
      </ng-container>

      <app-comment-skeleton *ngIf="isCreatingReplies()"></app-comment-skeleton>

      <ng-container *ngIf="isLoadingReplies()">
        <app-comment-skeleton></app-comment-skeleton>
        <app-comment-skeleton></app-comment-skeleton>
        <app-comment-skeleton></app-comment-skeleton>
        <app-comment-skeleton></app-comment-skeleton>
        <app-comment-skeleton></app-comment-skeleton>
      </ng-container>

      <opac-button *ngIf="comment.replies?.lastEvaluatedKey" type="text" (click)="loadMoreReplies(comment.replies?.lastEvaluatedKey)">
        {{ 'info.comments.viewMoreReplies' | translate }}
        <opac-icon icon="expand_more" slot="end"></opac-icon>
      </opac-button>
    </div>
  </div>
</article>

<opac-confirmation-dialog
  [acceptLabel]="'info.comments.actions.delete'"
  [cancelLabel]="'common.cancel'"
  [open]="showDeleteCommentConfirmModal()"
  [title]="'info.comments.delete.confirmTitle' | translate"
  (accept)="deleteComment()"
  (cancel)="showDeleteCommentConfirmModal.set(false)">
  {{ 'info.comments.delete.confirmDescription' | translate }}
</opac-confirmation-dialog>
